import { createReducer, on } from '@ngrx/store';

import { CurrentPersonStateActions } from './current-person-state.actions';
import { CurrentPersonStateModel, initialCurrentPersonState } from './current-person-state.model';

export const currentPersonStateReducer = createReducer<CurrentPersonStateModel>(
  initialCurrentPersonState,
  on(
    CurrentPersonStateActions.getLoginPersonSuccess,
    CurrentPersonStateActions.updateCurrentPerson,
    (state, { person }): CurrentPersonStateModel => ({
      ...state,
      isLoaded: true,
      person,
    })
  ),
  on(CurrentPersonStateActions.getLoginPersonFailed, (): CurrentPersonStateModel => initialCurrentPersonState),
  on(CurrentPersonStateActions.appLogout, (): CurrentPersonStateModel => initialCurrentPersonState)
);
